import {Component, Input} from '@angular/core';
// @ts-ignore
import { default as j } from '../../../../package.json';

@Component({
  selector: 'app-base-layout',
  templateUrl: './base-layout.component.html',
  styleUrls: ['./base-layout.component.scss']
})
export class BaseLayoutComponent {
  @Input() showHeader = true;
  @Input() showFooter = true;
  @Input() darkMode = false;
  version = j.version;
  year = new Date().getFullYear();

  constructor() { }

}
